import { Switch } from 'antd';
import styled from 'styled-components';

import { StyledSwitchProps } from './types';

export const StyledSwitch = styled(Switch)<StyledSwitchProps>``;
